import { memo, useCallback } from 'react';

import { Layout } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { Sort } from '@src/components/ProductList/components/Sort';
import { FILTERS_NAMES, SORT_SOURCE_AB, SORT_SOURCE_UTM } from '@src/constants/filters';
import type { IFilter } from '@src/hooks/useFilters';
import { useHasUtmLabel } from '@src/reducers/route';

import styles from './styles.module.scss';

interface IProps {
    filter: IFilter;
}

export const SortPanel: React.FC<IProps> = memo(({ filter }) => {
    const isMobile = useIsMobile();
    const { filters, setFilter } = filter;
    const hasUtmLabel = useHasUtmLabel();

    const sort = filters[FILTERS_NAMES.SORT];

    const onSort = useCallback<typeof setFilter>(
        (key, value) => {
            setFilter(key, value);
        },
        [setFilter],
    );

    if (isMobile) {
        return <Sort value={sort} onChange={onSort} className={styles.sortWrapper} source={SORT_SOURCE_AB} />;
    }

    return (
        <div className={styles.container}>
            <Layout className={styles.layout}>
                <Sort value={sort} onChange={onSort} source={hasUtmLabel ? SORT_SOURCE_UTM : SORT_SOURCE_AB} />
            </Layout>
        </div>
    );
});
